<template>
  <div>
    <div class="soluBanner">
      <Carousel :bannerUrl="bannerUrl"></Carousel>
    </div>
    <!-- 园区动态 -->
    <div class="park_dynamic">
      <div class="title flex">
        <!-- <div class="title_left">
          <span class="titleBig">NEWS</span>
          <span class="titleSmill">小镇资讯</span>
        </div> -->
        <p class="title_Css" style="padding-left: 48px;">泵都资讯</p>
        <p class="parkMore" @click="getMoreNews">查看更多 > </p>
      </div>
      <div class="park_box flex">
        <div class="park_box_img">
          <el-carousel class="carouseItems" indicator-position="outside">
            <el-carousel-item v-for="(items, index) in parkTopList" :key="index" v-if="index < 4">
              <img :src="items.pictureUrl" @click="getDetails(items.uuid)" alt="" width="100%" height="100%" />
              <!-- <h3 class="small">{{ item.title }}</h3> -->
              <div class="new_left_title">
                <p @click="getDetails(items.uuid)">{{ items.title }}</p>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="park_box_right">
          <div class="park_right_box flex" v-for="(items, index) in parkTopList" :key="index" v-if="index > 3"
            @click="getDetails(items.uuid)">
            <div class="park_right_img">
              <img :src="items.pictureUrl" alt="" />
            </div>
            <div class="park_right_text">
              <p class="park_right_textp">
                {{ items.title }}
              </p>
              <p class="park_right_textM">
                {{ items.summary }}
              </p>
              <div class="park_right_times flex">
                <p>{{ items.publishDate.substring(0, 10) }}</p>
                <p>{{ items.publishDate.substring(10) }}</p>
                <p class="flex" style="align-items: center">
                  <i class="iconfont" style="margin-right:3px;margin-top:2px">&#xe611;</i>
                  <span>{{ items.pageViews }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 示范园区 -->
    <div class="park_demonstration">
      <div class="title flex">
        <!-- <div class="title_left">
          <span class="titleBig">SERVICE</span>
          <span class="titleSmill">服务中心</span>
        </div> -->
        <p class="title_Css">服务中心</p>
      </div>
      <div class="park_car">
        <SwiperPark />
      </div>
    </div>
    <!-- 重点企业 -->
    <div class="park_enterprise">
      <div class="title flex">
        <!-- <div class="title_left">
          <span class="titleBig">ENTERPRISE</span>
          <span class="titleSmill">重点企业</span>
        </div> -->
        <p class="title_Css">重点企业</p>
      </div>
      <div v-if="enterPriseList.length" style="margin-top: 20px;">
        <EmterSwiper />
      </div>
      <p class="noMess" v-else>
        <img src="../../assets/noMesge.jpg" alt="" style="height:200px" />
      </p>
    </div>
  </div>
</template>

<script>
import SwiperPark from "../parkSwiper/swiper";
import EmterSwiper from "../parkSwiper/emterSwiper";
import Carousel from "../carousel/carousel";
import {
  getNewsItemList,
  getParkDetailData,
  getEnterpriseMangeList,
  operationSystem,
} from "../../utils/interface";
import { mapState } from "vuex";

export default {
  name: "park",
  metaInfo: {
    title: '泵都风采-用户通过VR技术在线浏览盐湖区水泵特色专业镇概况-水泵云', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: '水泵 | 水泵云 | 盐湖水泵特色镇云平台| 泵业特色小镇 | 水泵智造行业平台 | 农业水泵解决方案| 工业互联网平台 |泵行业资讯| 盐湖区水泵 | 山西运城水泵之乡'
    }, {                 // set meta
      name: 'description',
      content: '通过VR技术构建小镇线上展厅，用户可在线通过视频、VR等方式浏览盐湖区水泵特色专业镇概况。'
    }],
  },
  components: { SwiperPark, Carousel, EmterSwiper },
  data() {
    return {
      // 查询条件
      bannerUrl: [],
      title: "",
      descriptions: "",
      areaUuid: "",
      imageUrl: "",
      programUuid: "",
      sorter: "page_views",
      current: 0,
      pageSize: 7,
      parkTopList: [],
      linkUrl: '',
      // 地图
      ifbox: false,
      TipsList: [],
      mapPopX: "0px",
      mapPopY: "0px",
      mapShow: false,
      areaList: [], // 园区分布
      areaInfoList: [],
      enterPriseList: [], // 重点企业
      setIn: null,
      enterDetails: {},
    };
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        //banner图
        this.getIndexVocationalWork();
        // 园区动态
        this.getNewsItemList();
        // 重点企业
        this.getEnterpriseMangeList();
      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    // 查看更多
    getMoreNews(){
      window.open('parkDynamic', '_blank')
    },
    goToParkVr(items) {
      if (items.vrUrl) {
        let routeData = this.$router.resolve({
          name: "VeiwsUrl",
          query: {
            url: items.vrUrl,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (items.vrList.length > 0) {
        let routeData = this.$router.resolve({
          name: "veiws",
          params: { uuid: items.uuid },
        });
        window.open(routeData.href, "_blank");
      }else {
        window.open(items.url, "_blank");
      }
    },
    // banner图片
    getIndexVocationalWork() {
      operationSystem({
        type: "PUMP",
        survival: "ENABLE"
      })
        .then((res) => {
          this.bannerUrl = res.list
          this.bannerUrl.map(item => {
            item.value = item.imgUrl;
          })
        })
        .catch(function (error) { });
    },
    // 园区动态
    getNewsItemList() {
      let params = {
        status: "PUBLISH",
        // programUuid: this.programUuid,
        // sorter: this.sorter,
        origin: "PARK",
        current: this.current,
        pageSize: this.pageSize,
      };
      getNewsItemList(params).then((res) => {
        if (res.success) {
          this.parkTopList = res.data;
          console.log(11111, res)
        }
      });
    },
    // 重点企业
    getEnterpriseMangeList() {
      let enterpriseParam = {
        // sort: "KEY_ENTERPRISE_DATE",
        isKeyEnterprise: true,
        current: 1,
        pageSize: 5,
      };
      getEnterpriseMangeList(enterpriseParam).then((res) => {
        this.enterPriseList = res.list.map(x => {
						return x;
					})
        this.enterDetails = res.list[0]
      });
    },
    getEnterDetalis(items) {
      this.enterDetails = items;
    },
    goToDetail(uuid) {
      // this.$router.push({ name: "allPark", params: { uuid: uuid } });
      let routeData = this.$router.resolve({
        name: "allPark",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    goToAreaVrDetail(uuid) {
      this.$router.push({ name: "veiws", params: { uuid: uuid } });
    },
    getDetails(uuid) {
      // this.$router.push({ name: "parkDetails", params: { uuid: uuid } });
      let routeData = this.$router.resolve({
        name: "parkDetails",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    getCallOur() {
      // this.$router.push("/caseDetails?#tabs");
    },
    mapDivClick(e) {
      // console.log(e.offsetX, e.offsetY);
      // 计算
      let comTop = 750 - 380;
      let comBottom = this.$refs.ChinaMap.offsetWidth - 310;
      // 计算高度是否超过盒子高度
      if (comTop < e.offsetY) {
        this.mapPopX = comTop + "px";
      } else {
        this.mapPopX = e.offsetY + "px";
      }
      // 计算宽度是否超过盒子宽度

      if (comBottom < e.offsetX) {
        console.log(444);

        this.mapPopY = comBottom + "px";
      } else {
        this.mapPopY = e.offsetX + "px";
      }
    },
    dealWithData() {
      var geoCoordMap = {
        海门: [121.15, 31.89],
        鄂尔多斯: [109.781327, 39.608266],
        招远: [120.38, 37.35],
        舟山: [122.207216, 29.985295],
        齐齐哈尔: [123.97, 47.33],
        盐城: [120.13, 33.38],
        赤峰: [118.87, 42.28],
        青岛: [120.33, 36.07],
        乳山: [121.52, 36.89],
        金昌: [102.188043, 38.520089],
        泉州: [118.58, 24.93],
        莱西: [120.53, 36.86],
        日照: [119.46, 35.42],
        胶南: [119.97, 35.88],
        南通: [121.05, 32.08],
        拉萨: [91.11, 29.97],
        云浮: [112.02, 22.93],
        梅州: [116.1, 24.55],
        文登: [122.05, 37.2],
        上海: [121.48, 31.22],
        攀枝花: [101.718637, 26.582347],
        威海: [122.1, 37.5],
        承德: [117.93, 40.97],
        厦门: [118.1, 24.46],
        汕尾: [115.375279, 22.786211],
        潮州: [116.63, 23.68],
        丹东: [124.37, 40.13],
        太仓: [121.1, 31.45],
        曲靖: [103.79, 25.51],
        烟台: [121.39, 37.52],
        福州: [119.3, 26.08],
        瓦房店: [121.979603, 39.627114],
        即墨: [120.45, 36.38],
        抚顺: [123.97, 41.97],
        玉溪: [102.52, 24.35],
        张家口: [114.87, 40.82],
        阳泉: [113.57, 37.85],
        莱州: [119.942327, 37.177017],
        湖州: [120.1, 30.86],
        汕头: [116.69, 23.39],
        昆山: [120.95, 31.39],
        宁波: [121.56, 29.86],
        湛江: [110.359377, 21.270708],
        揭阳: [116.35, 23.55],
        荣成: [122.41, 37.16],
        连云港: [119.16, 34.59],
        葫芦岛: [120.836932, 40.711052],
        常熟: [120.74, 31.64],
        东莞: [113.75, 23.04],
        河源: [114.68, 23.73],
        淮安: [119.15, 33.5],
        泰州: [119.9, 32.49],
        南宁: [108.33, 22.84],
        营口: [122.18, 40.65],
        惠州: [114.4, 23.09],
        江阴: [120.26, 31.91],
        蓬莱: [120.75, 37.8],
        韶关: [113.62, 24.84],
        嘉峪关: [98.289152, 39.77313],
        广州: [113.23, 23.16],
        延安: [109.47, 36.6],
        太原: [112.53, 37.87],
        清远: [113.01, 23.7],
        中山: [113.38, 22.52],
        昆明: [102.73, 25.04],
        寿光: [118.73, 36.86],
        盘锦: [122.070714, 41.119997],
        长治: [113.08, 36.18],
        深圳: [114.07, 22.62],
        珠海: [113.52, 22.3],
        宿迁: [118.3, 33.96],
        咸阳: [108.72, 34.36],
        铜川: [109.11, 35.09],
        平度: [119.97, 36.77],
        佛山: [113.11, 23.05],
        海口: [110.35, 20.02],
        江门: [113.06, 22.61],
        章丘: [117.53, 36.72],
        肇庆: [112.44, 23.05],
        大连: [121.62, 38.92],
        临汾: [111.5, 36.08],
        吴江: [120.63, 31.16],
        石嘴山: [106.39, 39.04],
        沈阳: [123.38, 41.8],
        苏州: [120.62, 31.32],
        茂名: [110.88, 21.68],
        嘉兴: [120.76, 30.77],
        长春: [125.35, 43.88],
        胶州: [120.03336, 36.264622],
        银川: [106.27, 38.47],
        张家港: [120.555821, 31.875428],
        三门峡: [111.19, 34.76],
        锦州: [121.15, 41.13],
        南昌: [115.89, 28.68],
        柳州: [109.4, 24.33],
        三亚: [109.511909, 18.252847],
        自贡: [104.778442, 29.33903],
        吉林: [126.57, 43.87],
        阳江: [111.95, 21.85],
        泸州: [105.39, 28.91],
        西宁: [101.74, 36.56],
        宜宾: [104.56, 29.77],
        呼和浩特: [111.65, 40.82],
        成都: [104.06, 30.67],
        大同: [113.3, 40.12],
        镇江: [119.44, 32.2],
        桂林: [110.28, 25.29],
        张家界: [110.479191, 29.117096],
        宜兴: [119.82, 31.36],
        北海: [109.12, 21.49],
        西安: [108.95, 34.27],
        金坛: [119.56, 31.74],
        东营: [118.49, 37.46],
        牡丹江: [129.58, 44.6],
        遵义: [106.9, 27.7],
        绍兴: [120.58, 30.01],
        扬州: [119.42, 32.39],
        常州: [119.95, 31.79],
        潍坊: [119.1, 36.62],
        重庆: [106.54, 29.59],
        台州: [121.420757, 28.656386],
        南京: [118.78, 32.04],
        滨州: [118.03, 37.36],
        贵阳: [106.71, 26.57],
        无锡: [120.29, 31.59],
        本溪: [123.73, 41.3],
        克拉玛依: [84.77, 45.59],
        渭南: [109.5, 34.52],
        马鞍山: [118.48, 31.56],
        宝鸡: [107.15, 34.38],
        焦作: [113.21, 35.24],
        句容: [119.16, 31.95],
        北京: [116.46, 39.92],
        徐州: [117.2, 34.26],
        衡水: [115.72, 37.72],
        包头: [110, 40.58],
        绵阳: [104.73, 31.48],
        乌鲁木齐: [87.68, 43.77],
        枣庄: [117.57, 34.86],
        杭州: [120.19, 30.26],
        淄博: [118.05, 36.78],
        鞍山: [122.85, 41.12],
        溧阳: [119.48, 31.43],
        库尔勒: [86.06, 41.68],
        安阳: [114.35, 36.1],
        开封: [114.35, 34.79],
        济南: [117, 36.65],
        德阳: [104.37, 31.13],
        温州: [120.65, 28.01],
        九江: [115.97, 29.71],
        邯郸: [114.47, 36.6],
        临安: [119.72, 30.23],
        兰州: [103.73, 36.03],
        沧州: [116.83, 38.33],
        临沂: [118.35, 35.05],
        南充: [106.110698, 30.837793],
        天津: [117.2, 39.13],
        富阳: [119.95, 30.07],
        泰安: [117.13, 36.18],
        诸暨: [120.23, 29.71],
        郑州: [113.65, 34.76],
        哈尔滨: [126.63, 45.75],
        聊城: [115.97, 36.45],
        芜湖: [118.38, 31.33],
        唐山: [118.02, 39.63],
        平顶山: [113.29, 33.75],
        邢台: [114.48, 37.05],
        德州: [116.29, 37.45],
        济宁: [116.59, 35.38],
        荆州: [112.239741, 30.335165],
        宜昌: [111.3, 30.7],
        义乌: [120.06, 29.32],
        丽水: [119.92, 28.45],
        洛阳: [112.44, 34.7],
        秦皇岛: [119.57, 39.95],
        株洲: [113.16, 27.83],
        石家庄: [114.48, 38.03],
        莱芜: [117.67, 36.19],
        常德: [111.69, 29.05],
        保定: [115.48, 38.85],
        湘潭: [112.91, 27.87],
        金华: [119.64, 29.12],
        岳阳: [113.09, 29.37],
        长沙: [113, 28.21],
        衢州: [118.88, 28.97],
        廊坊: [116.7, 39.53],
        菏泽: [115.480656, 35.23375],
        合肥: [117.27, 31.86],
        武汉: [114.31, 30.52],
        大庆: [125.03, 46.58],
      };
      var data = [];
      for (var key in geoCoordMap) {
        data.push({ name: key, value: geoCoordMap[key] });
      }
      return data;
    },
    // 查看更多
    getParkDynamicMore() {
      // this.$router.push("/parkDynamic");
      let routeData = this.$router.resolve({
        name: "parkDynamic",
      });
      window.open(routeData.href, "_blank");

    },
  },
};
</script>

<style scoped lang="less">
.noMess {
  width: 100%;
  text-align: center;
}

.blue {
  color: #009999;
}

.title {
  width: 1200px;
  height: 26px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 14px;
  margin-top: 40px;

  .title_left {
    text-align: center;
    margin-top: 30px;
    height: 88px;

    .titleBig {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, 0);
      font-size: 80px;
      font-family: ABCMarfa-Bold, ABCMarfa;
      font-weight: bold;
      color: #0099993d;
    }

    .titleSmill {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -15%);
      font-size: 28px;
      font-weight: 600;
      color: #1D1D1D;
    }
  }
}

.soluBanner {
  position: relative;
  width: 100%;

  img {
    width: 100%;
  }

  .soluBanBox {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1200px;
    transform: translate(-50%, -50%);
    color: #fff;

    h2 {
      font-size: 38px;
      letter-spacing: 10px;
    }

    .soluBanText {
      margin: 8px 0 60px;

      p:nth-child(1) {
        font-size: 17px;
      }

      p:nth-child(2) {
        font-size: 9px;
      }
    }

    button {
      border: 1px solid #fff;
      color: #fff;
      background: none;
      padding: 2px 5px;
    }
  }
}

//  园区动态
.park_dynamic {
  width: 1200px;
  margin: 0 auto;

  .park_box {
    margin-top: 20px;
  }

  .park_box_img {
    cursor: pointer;
    width: 542px;
    // height: 304px;
    flex-shrink: 0;

    .carouseItems {
      position: relative;
      border-radius: 10px;

      .new_left_title {
        background-image: url("../../assets/bannerbottom.png");
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        height: 50px;
        width: 100%;
        color: #fff;
        line-height: 60px;
        padding-left: 40px;
        font-size: 18px;
        border-radius: 0 0 10px 10px;
        box-sizing: border-box;
        p {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 76%;
        }
      }
      /deep/.el-carousel__indicators--horizontal {
        bottom: 16px;
        left: 87%;
        transform: translateX(0);
      }

      /deep/.el-carousel__button {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #009999;
      }

      /deep/.el-carousel__indicator.is-active button {
        width: 16px !important;
        border-radius: 6px !important;
      }
      /deep/.el-carousel__indicators {
        position: absolute;
        bottom: 5px;
        right: 10px;
        // top: auto;
        // width: 100%;
      }
    }

    .carouseItems:hover {
      .new_left_title {
        color: #009999;
      }
    }

    .el-carousel__item h3 {
      color: #fff;
      opacity: 0.75;
      line-height: 150px;
      padding: 10px 20px;
      position: absolute;
      bottom: 0px;
      line-height: 22px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 93%;
      font-size: 15px;
      background: #0000005c;
    }

    .el-carousel__item img {}

    .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n + 1) {
      background-color: #d3dce6;
    }

    /deep/.el-carousel__button {
      width: 4px !important;
      height: 4px !important;
      border-radius: 50% !important;
    }
  }
  .parkMore {
    cursor: pointer;
    font-size: 13px;
    color: #000;
    &:hover {
      color: #009999;
    }
  }

  .park_box_right {
    width: 100%;
    .park_right_box {
      margin-left: 30px;
      // border-bottom: 1px solid #efefef;
      padding-bottom: 5px;
      margin-bottom: 26px;

      // height: 110px;
      .park_right_img {
        flex-shrink: 0;
        background: #efefef;
        width: 144px;
        // height: 81px;
        margin-right: 20px;
        cursor: pointer;
        border-radius: 8px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .park_right_text {
        width: 100%;
        position: relative;
        cursor: pointer;

        .park_right_textp {
          display: -webkit-box;
          overflow: hidden;
          white-space: normal !important;
          text-overflow: ellipsis;
          word-wrap: break-word;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        .park_right_textM {
          font-size: 12px;
          color: #777;
          margin-top: 8px;
          display: -webkit-box;
          overflow: hidden;
          white-space: normal !important;
          text-overflow: ellipsis;
          word-wrap: break-word;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .park_right_times {
          position: absolute;
          bottom: -6px;
          font-size: 12px;
          color: #c7c7c7;
          align-items: center;

          p {
            margin-right: 25px;
          }
        }
      }
    }

    .park_right_box:nth-last-child(1) {
      border-bottom: none;
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
}

// 示范园区
.park_demonstration {
  .park_car {
    // background: #efefef;
    margin-top: 20px;
    background-image: url("../../assets/WechatIMG245.png");
    background-size: 100% 100%;

    .park_car_img {
      width: 100%;
      height: 200px;
      background: #009999;
    }

    .park_car_text {
      padding: 20px 15px 10px;

      height: 44%;
      border-bottom: 1px solid #aed4ff;

      h2 {
        margin-bottom: 15px;
        font-size: 20px;
      }

      p {
        line-height: 24px;
        font-size: 14px;
        color: #777;
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
    }

    .park_car_button {
      button {
        color: #009999;
        border: none;
        background: #fff;
        width: 50%;
        padding: 10px 0;
      }

      button:nth-child(1) {
        border-right: 1px solid #aed4ff;
      }

      button:nth-child(2) {}
    }

    // /deep/.el-carousel__arrow--right {
    //   right: 200px;
    // }

    // /deep/.el-carousel__arrow--left {
    //   left: 200px;
    // }

    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 200px;
      margin: 0;
    }

    .el-carousel__item {
      // width: 360px;
      // height: 485px;
      background: #99a9bf;
    }

    // .el-carousel__item:nth-child(2n) {
    //   background-color: #99a9bf;
    // }

    // .el-carousel__item:nth-child(2n + 1) {
    //   background-color: #d3dce6;
    // }
  }
}

// 水泵打印产业园区分布
.td {
  .td_map {
    margin-top: 25px;

    .mapPosition {
      position: relative;
      background: #9fd7fc;

      // 地图弹框样式
      .map {
        align-items: center;
        position: absolute;
        z-index: 100;
        background: rgba(255, 255, 255, 0.797);
        padding: 20px;
        width: 400px;

        .mapImg {
          flex-shrink: 0;
          width: 90px;
          height: 90px;
          background: #efefef;
          border-radius: 50%;
          margin-right: 10px;

          /deep/.el-image {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }

          img {
            // width: 100%;
            // height: 100%;
            // border-radius: 10px 10px 0 0;
            display: inline-block;
          }
        }

        .mapMess {

          // padding: 20px 15px 10px;
          // border-bottom: 1px solid #009999;
          .mapMessT {
            font-size: 18px;
            font-weight: 500;

            // margin-bottom: 10px;
          }

          .mapMessP {
            font-size: 14px;
            color: #777;
            line-height: 25px;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }

        .mapMessBut {
          margin-top: 20px;

          button {
            color: #009999;
            padding: 6px 12px;
            border: 1px solid #009999;
            background: #fff;
            margin-right: 15px;
            width: 150px;
          }
        }
      }
    }
  }
}

// 重点企业
.park_enterprise {
  margin-top: 30px;
  width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/park/index.vue